export default {
  mediaGallery: 'گالری رسانه',
  createFolder: 'ایجاد پوشه',
  upload: 'بارگذاری',
  open: 'باز کردن',
  remove: 'حذف',
  rename: 'ویرایش نام',
  cut: 'بریدن',
  copy: 'کپی',
  paste: 'چسباندن',
  view: 'نمایش',
  refresh: 'تازه سازی',
  fileName: 'نام فایل',
  type: 'نوع',
  folder: 'پوشه',
  loading: 'در حال بارگیری',
  folderName: 'نام پوشه',
  cantMoveFolderToItself: 'شما نمی توانید یک پوشه را به داخل خودش انتقال دهید.',
  newName: 'نام تازه',
  nameAlreadyTaken: 'پوشه یا فایلی با این نام از قبل وجود دارد. لطفا نام دیگری انتخاب کنید.',
  Type: 'نوع'
}
